module.exports = __webpack_public_path__ + "img/pay.cfe65c56.svg";